module.exports = __webpack_public_path__ + "static/media/loading.e9d9e9f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading.gif
// module id = 107
// module chunks = 0